import React from "react";
import Mail from "@mui/icons-material/Mail";
import Phone from "@mui/icons-material/Phone";
import LocationOn from "@mui/icons-material/LocationOn";

const ContactInfo: React.FC = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@supportdecor.com";
  };

  const handlePhoneClick = () => {
    window.location.href = "tel:+201003234531";
  };

  const handleLocationClick = () => {
    window.open(
      "https://www.google.com/maps/search/?api=1&query=30.026888,31.501877", // Replace with your specific location coordinates
      "_blank"
    );
  };

  return (
    <div className="py-24 -mt-6 flex justify-between flex-row-reverse w-full px-12 max-md:flex-col max-md:items-center max-md:h-[800px] max-md:gap-24 max-md:mb-24 bg-white ] ">
      {/* Email Section */}
      <div
        className="flex gap-4  max-md:flex-col max-md:items-center text-center cursor-pointer"
        dir="rtl"
        onClick={handleEmailClick}
      >
        <div className="r-icon bg-primary p-3 h-fit">
          <Mail className="text-4xl" fontSize="large" />
        </div>
        <div className="l-container text-right">
          <div className="text-xl font-bold">البريد الإلكتروني</div>
          <div className="font-light text-lg">info@supportdecor.com</div>
        </div>
      </div>

      {/* Phone Section */}
      <div
        className="flex gap-4 max-md:flex-col max-md:items-center text-center cursor-pointer"
        dir="rtl"
        onClick={handlePhoneClick}
      >
        <div className="r-icon bg-primary p-3 h-fit">
          <Phone className="text-4xl" fontSize="large" />
        </div>
        <div className="l-container text-right">
          <div className="text-xl font-bold">رقم الهاتف</div>
          <div className="font-light text-lg">+201003234531</div>
        </div>
      </div>

      {/* Location Section */}
      <div
        className="flex gap-4 max-md:flex-col max-md:items-center text-center cursor-pointer"
        dir="rtl"
        onClick={handleLocationClick}
      >
        <div className="r-icon bg-primary p-3 h-fit">
          <LocationOn className="text-4xl" fontSize="large" />
        </div>
        <div className="l-container text-right">
          <div className="text-xl font-bold">العنوان</div>
          <div className="font-light text-lg max-w-[300px]">
            محافظة القاهرة - التجمع الخامس اللوتس الجنوبية - أمام سوديك المجاور
            للجامعة الأمريكية فيلا رقم (70)
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
